import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
import { Edit } from '@finect/tabular-icons/edit';
import { Save } from '@finect/tabular-icons/save';
import { Cancel } from '@finect/tabular-icons/cancel';
import { Trash2 } from '@finect/tabular-icons/trash2';
export var EditionAction = styled.button.withConfig({
  displayName: "EditionActions__EditionAction",
  componentId: "sc-1viizwk-0"
})(["position:absolute;top:", ";right:-20px;width:40px;height:40px;border-radius:40px;box-shadow:", ";cursor:pointer;background-color:#fff;color:", ";span{display:none;}", ";"], function (_ref) {
  var secondary = _ref.secondary;
  return secondary ? '67px' : '18px';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.boxShadow;
}, function (_ref3) {
  var theme = _ref3.theme,
    main = _ref3.main,
    dark = _ref3.dark;
  return main ? theme.buttonColor : dark ? theme.colors.font : theme.colors.negative;
}, maxMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    top: 0;\n    right: ", ";\n    padding: 0 12px;\n    border-radius: ", ";\n    width: 102px;\n    height: 36px;\n    text-align: left;\n\n    svg {\n      flex-shrink: 0;\n      width: 20px;\n    }\n\n    span {\n      display: block;\n      padding-left: 6px;\n      ", ";\n    }\n  "])), function (_ref4) {
  var secondary = _ref4.secondary;
  return secondary ? '15px' : '126px';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderRadius;
}, getFont(0)));
export var EditButton = function EditButton(_ref6) {
  var handleClick = _ref6.handleClick;
  return React.createElement(EditionAction, {
    main: true,
    onClick: handleClick,
    title: "Editar"
  }, React.createElement(Edit, null), React.createElement("span", null, "Editar"));
};
export var SaveButton = function SaveButton(_ref7) {
  var handleClick = _ref7.handleClick;
  return React.createElement(EditionAction, {
    main: true,
    onClick: handleClick,
    title: "Guardar cambios"
  }, React.createElement(Save, null), React.createElement("span", null, "Guardar"));
};
export var CancelButton = function CancelButton(_ref8) {
  var handleClick = _ref8.handleClick;
  return React.createElement(EditionAction, {
    secondary: true,
    dark: true,
    onClick: handleClick,
    title: "Descartar cambios"
  }, React.createElement(Cancel, null), React.createElement("span", null, "Cancelar"));
};
export var DeleteButton = function DeleteButton(_ref9) {
  var handleClick = _ref9.handleClick;
  return React.createElement(EditionAction, {
    secondary: true,
    onClick: handleClick,
    title: "Eliminar"
  }, React.createElement(Trash2, null), React.createElement("span", null, "Eliminar"));
};